<template>
  <div class="album-card" style="width: 220px;">
    <div class="position-relative">
      <b-img
          :src="album.preview || album.cover"
          fluid
          rounded
          style="width: 220px; height: 220px; object-fit: cover;"
      />
      <b-badge
          v-if="album.total_tracks"
          variant="dark"
          class="position-absolute"
          style="top: 8px; left: 8px; opacity: 0.85; font-size: 0.85rem;"
      >
        <feather-icon icon="MusicIcon" size="12" class="mr-25" />
        {{ album.total_tracks }}
      </b-badge>
      <b-button
          v-if="showAddCover"
          variant="success"
          class="btn-icon position-absolute"
          size="sm"
          style="bottom: 8px; right: 8px; opacity: 0.9;"
          v-b-tooltip.hover
          title="Добавить обложку"
          @click="$emit('add-cover', album)"
      >
        <feather-icon icon="ImageIcon" />
      </b-button>
    </div>

    <div class="mt-50">
      <strong class="d-block font-small-3 text-truncate">{{ album.name }}</strong>
      <!-- Страница релизов: артисты с id из БД — ссылки; кнопки создания/поиска
           живут в шапке панели треков, не на карточке. -->
      <div v-if="hasArtistsList" class="font-small-2 text-truncate">
        <span v-for="(artist, artistIndex) in album.artists_list" :key="artistIndex">
          <b-link
              v-if="artist.id"
              :to="{ name: 'artist-view', params: { id: artist.id } }"
              class="font-weight-bold text-primary"
          >{{ artist.name }}</b-link>
          <strong v-else>{{ artist.name }}</strong>
          <span v-if="artistIndex < album.artists_list.length - 1">, </span>
        </span>
      </div>
      <strong
          v-else-if="album.artists"
          class="d-block font-small-2 text-truncate text-primary"
      >{{ album.artists }}</strong>
      <div class="d-flex align-items-center" style="gap: 0.4rem;">
        <span v-if="album.release_date" class="text-muted font-small-2">{{ releaseDate }}</span>
        <b-badge v-if="album.album_type" :variant="typeVariant" pill class="font-small-1">
          <feather-icon :icon="typeIcon" size="10" class="mr-25" />
          {{ typeLabel }}
        </b-badge>
      </div>

      <b-button
          :variant="active ? 'primary' : 'flat-primary'"
          size="sm"
          class="mt-25 p-25 font-small-2"
          @click="$emit('toggle', album, source)"
      >
        <feather-icon
            :icon="active ? 'ChevronUpIcon' : 'ChevronDownIcon'"
            size="14"
            class="mr-25"
        />
        {{ active ? 'Скрыть треки' : 'Показать треки' }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { BImg, BBadge, BButton, BLink, VBTooltip } from 'bootstrap-vue'

const TYPE_LABELS = { album: 'Альбом', single: 'Сингл', compilation: 'Сборник' }
const TYPE_ICONS = { album: 'DiscIcon', single: 'FileIcon', compilation: 'LayersIcon' }
const TYPE_VARIANTS = { album: 'primary', single: 'info', compilation: 'warning' }

export default {
  name: 'AlbumCard',
  components: { BImg, BBadge, BButton, BLink },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    album: { type: Object, required: true },
    source: { type: String, required: true },
    active: { type: Boolean, default: false },
    showAddCover: { type: Boolean, default: true },
  },
  computed: {
    hasArtistsList() {
      return Array.isArray(this.album.artists_list) && this.album.artists_list.length > 0
    },
    typeLabel() {
      return TYPE_LABELS[this.album.album_type] || this.album.album_type
    },
    typeIcon() {
      return TYPE_ICONS[this.album.album_type] || 'DiscIcon'
    },
    typeVariant() {
      return TYPE_VARIANTS[this.album.album_type] || 'secondary'
    },
    releaseDate() {
      return this.formatReleaseDate(this.album.release_date, this.album.release_date_precision)
    },
  },
  methods: {
    formatReleaseDate(date, precision) {
      if (!date) return ''
      const parts = date.split('-')
      if (precision === 'year' || parts.length === 1) return parts[0]
      if (precision === 'month' || parts.length === 2) {
        const months = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек']
        const monthIndex = parseInt(parts[1], 10) - 1
        return `${months[monthIndex]} ${parts[0]}`
      }
      const d = new Date(date)
      return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short', year: 'numeric' })
    },
  },
}
</script>
